export const DEFAULT_ACCENT_COLOR = {
  light: "#1D7AFC",
  dark: "#1D7AFC",
};
